import React, { Fragment } from 'react'
import { FourColumnLayout, ThreeColumnLayout } from '../ColumnLayout'
import KeyboardHandler from './KeyboardHandler'

export default function AutoLayout({
  is3ColumnView,
  children,
  columnConfigs,
  conversationId,
}) {
  const Layout = is3ColumnView ? ThreeColumnLayout : FourColumnLayout
  let config = columnConfigs['4']
  if (is3ColumnView) {
    config = conversationId
      ? columnConfigs['3-page']
      : columnConfigs['3-overview']
  }
  return (
    <Fragment>
      <KeyboardHandler />
      <Layout columnConfig={config}>{children}</Layout>
    </Fragment>
  )
}
